import {
  Vaccine,
  VerifyAppointmentSchedulerTokenResponse
} from '../../services/service-mappers/AppointmentSchedulingMapper';
import {
  APPOINTMENT_LOGIN,
  APPOINTMENT_LOGOUT,
  PATIENT_APPOINTMENT_TOKEN,
  SET_APPOINTMENT_PORTAL_COMMON,
  SET_APPOINTMENT_PORTAL_INSURANCE_DETAILS,
  SET_AVAILABLE_VACCINE_LIST
} from './Index';

export const _appointmentPortalLogin = (isLogin: any): any => async (
  dispatch: any
) => {
  dispatch({
    type: APPOINTMENT_LOGIN,
    payload: {isLogin}
  });
};

export const _setPatientAppointmentToken = (
  patientAppointmentToken: any
): any => async (dispatch: any) => {
  dispatch({
    type: PATIENT_APPOINTMENT_TOKEN,
    payload: {patientAppointmentToken}
  });
};

export const _appointmentPortalLogout = (): any => async (dispatch: any) => {
  dispatch({
    type: APPOINTMENT_LOGOUT,
    payload: {}
  });
};

export const _setAppointmentPortalInsuranceDetails = (payload: {
  id: number;
  patient_id: number;
  file_id1: string;
  file_id2: string;
}): any => async (dispatch: any) => {
  dispatch({
    type: SET_APPOINTMENT_PORTAL_INSURANCE_DETAILS,
    payload: payload
  });
};

export const _setAppointmentPortalCommonDetails = (
  payload: VerifyAppointmentSchedulerTokenResponse
): any => async (dispatch: any) => {
  dispatch({
    type: SET_APPOINTMENT_PORTAL_COMMON,
    payload: payload
  });
};

export const _setAvailableVaccinesList = (vaccineList: Vaccine[]): any => (
  dispatch: any
) => {
  dispatch({
    type: SET_AVAILABLE_VACCINE_LIST,
    payload: {vaccineList}
  });
};
